import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import React, {useState} from "react";
import {Dataset} from "./models/types";
import {Divider} from "primereact/divider";

import {DatasetInfo} from "api/apiModels";
import {InputText} from "primereact/inputtext";
import useDebounce from "../../../hooks/useDebounce";
import PaginatorWithoutTotalCount from "../../basic/PaginatorWithoutTotalCount";
import {useGetPaginatedDatasets} from "api/api-hooks/datasets-hooks";


const DatasetSelection = ({datasets, setDatasets}:
                              { datasets: Array<Dataset>, setDatasets: (arr: Array<Dataset>) => void }) => {
    const [searchBar, setSearchBar] = useState("");
    const searchValue = useDebounce<string>(searchBar, {
        delay: 400, callbackOnTime: () => {
            setLazyParams(old => ({...old, page: 0}))
        }
    })
    const [lazyParams, setLazyParams] = useState({page: 0, rows: 30});

    const {
        data,
        isLoading,
        isError
    } = useGetPaginatedDatasets(searchValue, lazyParams.page, lazyParams.rows, {refetchOnWindowFocus: false});

    const handleDatasetSelection = ({originalEvent, value}: { value: any, originalEvent: any }) => {
        if (originalEvent && originalEvent.altKey) {
            setDatasets([value]);
            return
        }
        if (datasets.some((dataset) => dataset.identifier === value.identifier)) {
            setDatasets([...datasets.filter(obj => obj.identifier !== value.identifier)]);
        } else {
            setDatasets([...datasets, value]);
        }
    }

    const rowClass = (data: any) => ({"row-selected": datasets.find((s) => s.identifier === data.identifier)});

    if (isError) {
        return <div>Error while fetching datasets...</div>
    }

    return <div className="selectionPanel fullWidth">
        <div style={{position: "relative"}}>
            <i className="pi pi-search"
               style={{position: "absolute", top: "11px", left: "5px", 'fontSize': '1.4em'}}/>
            {searchValue && <i className="pi pi-times"
                               style={{
                                   cursor: "pointer",
                                   position: "absolute",
                                   top: "11px",
                                   right: "5px",
                                   'fontSize': '1.4em'
                               }}
                               onClick={() => setSearchBar("")}
            />}
            <InputText value={searchBar}
                       onChange={(e) => setSearchBar(e.target.value)}
                       placeholder="Search"
                       style={{width: "100%", paddingLeft: "2.2rem"}}

            />
        </div>
        <Divider/>
        <div style={{flexGrow: 1}}>
            <DataTable value={data?.map((pd: DatasetInfo) => ({...pd, formatedTitle: pd.toString()}))}
                       lazy
                       selectionMode="single"
                       selection={datasets.map((s) => s.formatedTitle)}
                       onSelectionChange={handleDatasetSelection}
                       dataKey="identifier"
                       responsiveLayout="scroll"
                       className="text row fullWidth"
                       rowClassName={rowClass}
                       emptyMessage="No datasets found."
                       showGridlines
                       loading={isLoading}
            >
                <Column key="dataset"
                        field="title"
                        header="Dataset"
                        className="row"
                        style={{width: "30rem"}}
                />
                <Column key="unit"
                        field="unit"
                        header="Unit"
                        className="row"
                        style={{width: "10px", whiteSpace: "nowrap"}}
                />
            </DataTable>
        </div>
        <PaginatorWithoutTotalCount page={lazyParams.page}
                                    maxRows={lazyParams.rows}
                                    rows={data?.length}
                                    setPage={(page) => setLazyParams(old => ({...old, page: page}))}
        />
    </div>
}


export default DatasetSelection;